import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1989adce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "music-player-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MusicPlayer = _resolveComponent("MusicPlayer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MusicPlayer, { data: _ctx.audioData }, null, 8, ["data"])
  ]))
}